import { CheckCircle2 } from "lucide-react";

const STEPS = [
  {
    title: "Get the lay of the land",
    description:
      "Skim the category that matches your decision — borrowing, investing, business, real estate, or vehicles.",
    cta: { label: "Browse categories", to: "/#categories" },
  },
  {
    title: "Run the numbers",
    description:
      "Use a calculator before signing anything. Five minutes here saves real dollars later.",
    cta: { label: "Open calculators", to: "/calculators" },
  },
  {
    title: "Read one guide",
    description:
      "Short, jargon-free articles that explain the math behind the decision you're making.",
    cta: { label: "Read the guides", to: "/articles" },
  },
];

export function NextSteps() {
  return (
    <section className="bg-[#F8FAF9] mml-section">
      <div className="mml-container">
        <div className="max-w-2xl">
          <p className="mml-overline">Recommended next steps</p>
          <h2 className="mt-2 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            New here? Start with these three moves.
          </h2>
        </div>
        <ol className="mt-10 grid gap-5 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <li
              key={s.title}
              className="rounded-2xl border border-slate-200 bg-white p-7"
            >
              <div className="flex items-center gap-3">
                <span className="grid h-8 w-8 place-items-center rounded-full bg-emerald-100 font-mono text-sm font-bold text-emerald-800">
                  {i + 1}
                </span>
                <CheckCircle2 className="h-5 w-5 text-emerald-600" />
              </div>
              <h3 className="mt-4 text-lg font-bold text-slate-900">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">
                {s.description}
              </p>
              <a
                href={s.cta.to}
                className="mt-5 inline-flex text-sm font-semibold text-emerald-700 hover:text-emerald-900"
              >
                {s.cta.label} →
              </a>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
